export enum OperativeValidation {
  none = 'NONE',
  sms = 'SMS',
  email = 'EMAIL',
}

export enum OperativePageState {
  contribution = 'C',
  period_contribution = 'PC',
  period_contribution_edit = 'PCE',
  model_portfolio_change = 'MPC',
  partial_refund = 'PR',
  total_refund = 'TR',
  sms_validation = 'SMS',
  success = 'OK',
}

export enum OperativeSmsError {
  maxSms = 'MaxSMSs',
  invalidSmsCode = 'InvalidSMSCode',
  invalidInputs = 'Invalid_Inputs',
  expiredSms = 'Expired',
}
